import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deletePassport } from "../../services/passports";

import useToast from "../useToast";

import { IWorkerImmigrationDocs } from "../../interfaces/services";
import { IPassport } from "../../interfaces/entities";

export interface IPayload {
    foreignWorkerId: number;
    payload: {
        passportId: number;
    };
    setIsProcessing: Function;
    onSuccess: (passports: IPassport[]) => void;
};

export interface IResponse {
    error?: string;
    message: string;
    statusCode: number;
};

const useDeletePassport = () => {
    const queryClient = useQueryClient();

    const { addToast } = useToast();

    const mutationFn = async (data: IPayload): Promise<IResponse> => {
        return await deletePassport(data.payload.passportId);
    };

    return useMutation({
        mutationFn,
        onSuccess: async (response: IResponse, variables: IPayload) => {
            if (response) {
                addToast({
                    type: 'success',
                    title: 'Passport deleted successfully.',
                });

                await queryClient.invalidateQueries({ queryKey: ['foreign_worker_immigration_docs'] });
                const newData: IWorkerImmigrationDocs | undefined = queryClient.getQueryData(['foreign_worker_immigration_docs', variables.foreignWorkerId]);
                variables.onSuccess(newData?.passports ?? []);
            };
        },
        onError: (error: IResponse, variables: IPayload) => {
            addToast({
                type: 'error',
                title: 'Error occured',
                message: error.message
            });
        },
        onSettled: (data: IResponse | undefined, error: IResponse | null, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useDeletePassport;